import fetch from "auth/FetchInterceptor";

const dashboardService = {};

dashboardService.getCompanyGuidelines = function () {
	return fetch({
		url: "/v1/rest/company-guideline",
		method: "get",
	});
};

export default dashboardService;
